import { render } from "./customerModel.vue?vue&type=template&id=6caf3d72"
import script from "./customerModel.vue?vue&type=script&lang=js"
export * from "./customerModel.vue?vue&type=script&lang=js"

import "./customerModel.vue?vue&type=style&index=0&id=6caf3d72&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__